import { CombinedGraphQLErrors } from '@apollo/client/errors'

export type PostFetchFailure = 'unavailable' | 'accessDenied' | 'unexpected'

/**
 * Keyed off `extensions.code`, not message text: `getUpdate` denies the org and
 * channel gates with identical payloads, so `FORBIDDEN` can't be narrowed past
 * "you can't see this post". A malformed id reads the same as a deleted one to
 * the reader, and `post` is non-null, so no error and no post also means gone.
 */
export const classifyPostFetchError = (error?: unknown): PostFetchFailure => {
  if (!error) {
    return 'unavailable'
  }

  if (!CombinedGraphQLErrors.is(error)) {
    return 'unexpected'
  }

  const codes = new Set(error.errors.map((each) => each.extensions?.code))

  if (codes.has('NOT_FOUND') || codes.has('BAD_USER_INPUT')) {
    return 'unavailable'
  }
  if (codes.has('FORBIDDEN')) {
    return 'accessDenied'
  }

  return 'unexpected'
}
